import { selectEffectiveUserType } from "../../../../modules/context/contextSelectors"
import { UserType } from "../../../../modules/login/loginTypes"
import { useAppSelector } from "../../../../modules/store/storeHooks"

// Own list, not MEETING_SERVICE_SUPERUSER_TYPES — that one gates module access, not pricing.
export const PRODUCT_WISH_PRICING_TYPES: ReadonlyArray<UserType> = [UserType.MERCHANT, UserType.SUPPLIER]

// Only the selling side prices a wish; whoever orders on a customer's behalf submits it unpriced.
export function useCanSetProductWishPrice(): boolean {
    const effectiveUserType = useAppSelector(selectEffectiveUserType)

    return !!effectiveUserType && PRODUCT_WISH_PRICING_TYPES.includes(effectiveUserType)
}
